"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const StorefrontCMSPage_1 = __importDefault(require("./StorefrontCMSPage"));
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
(0, client_1.gql) `
  query refundPolicy {
    storefrontShop {
      refundPolicy {
        title
        body
      }
    }
  }
`;
function RefundPolicyPage() {
    const { data, loading } = (0, MapmakerApi_1.useRefundPolicyQuery)();
    return (0, jsx_runtime_1.jsx)(StorefrontCMSPage_1.default, { page: data === null || data === void 0 ? void 0 : data.storefrontShop.refundPolicy, loading: loading });
}
exports.default = RefundPolicyPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVmdW5kUG9saWN5UGFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3BvbGljaWVzL1JlZnVuZFBvbGljeVBhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDRFQUEwQztBQUMxQywyQ0FBcUM7QUFDckMsMERBQWdFO0FBRWhFLElBQUEsWUFBRyxFQUFBOzs7Ozs7Ozs7Q0FTRixDQUFDO0FBRUYsU0FBd0IsZ0JBQWdCO0lBQ3RDLE1BQU0sRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLEdBQUcsSUFBQSxrQ0FBb0IsR0FBRSxDQUFDO0lBQ2pELE9BQU8sdUJBQUMsMkJBQU8sSUFBQyxJQUFJLEVBQUUsSUFBSSxhQUFKLElBQUksdUJBQUosSUFBSSxDQUFFLGNBQWMsQ0FBQyxZQUFZLEVBQUUsT0FBTyxFQUFFLE9BQU8sR0FBSSxDQUFDO0FBQ2hGLENBQUM7QUFIRCxtQ0FHQyJ9